// import React from "react";
// import "../../assets/css/mobNavbar.css";
// import { Col } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import {
//   RiNotificationBadgeFill,
//   RiShieldUserFill,
//   RiShoppingCartFill,
// } from "react-icons/ri";
// import { BsFillCalendarEventFill } from "react-icons/bs";
// import { GrDeliver } from "react-icons/gr";
// import { FaPowerOff } from "react-icons/fa";
// import Profile from "../../assets/img/jj2.jpg";

// export default function MobNavbar() {
//   return (
//     <>
//       <Col className="mobNavbar p-3 d-block d-lg-none">
//         <Col className="text-center">
//           <img
//             src={Profile}
//             alt="sivarm farms prodile"
//             height="auto"
//             width="60%"
//           />
//         </Col>
//         <Col className="mobNavbarMenu mt-4">
//           <ul>
//             <li>
//               <Link to="/notification">
//                 <RiNotificationBadgeFill
//                   className="text-dark me-1"
//                   style={{ fontSize: "1em" }}
//                 />
//                 Notifications
//               </Link>
//             </li>
//             <li>
//               <Link to="/userDetails">
//                 <RiShieldUserFill
//                   className="text-dark me-1"
//                   style={{ fontSize: "1em" }}
//                 />
//                 Managing Users
//               </Link>
//             </li>
//             <li>
//               <Link to="/productDetails">
//                 <RiShoppingCartFill
//                   className="text-dark me-1"
//                   style={{ fontSize: "1em" }}
//                 />
//                 Product List
//               </Link>
//             </li>
//             <li>
//               <Link to="/productOfMonth">
//                 <BsFillCalendarEventFill
//                   className="text-dark me-2"
//                   style={{ fontSize: "1em" }}
//                 />
//                 Product Of The Month
//               </Link>
//             </li>
//             <li>
//               <Link to="/courier">
//                 <GrDeliver
//                   className="text-dark me-2"
//                   style={{ fontSize: "1em" }}
//                 />
//                 Courier
//               </Link>
//             </li>
//             <li>
//               <Link to="/">
//                 <FaPowerOff
//                   className="text-dark me-1"
//                   style={{ fontSize: "1em" }}
//                 />
//                 Logout
//               </Link>
//             </li>
//           </ul>
//         </Col>
//       </Col>
//     </>
//   );
// }

import React from "react";
import "../../assets/css/mobNavbar.css";
import { Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  RiNotificationBadgeFill,
  RiShieldUserFill,
  RiShoppingCartFill,
} from "react-icons/ri";
import { BsFillCalendarEventFill } from "react-icons/bs";
import { GrDeliver } from "react-icons/gr";
import { FaPowerOff } from "react-icons/fa";
import Profile from "../../assets/img/logos.jpg";

export default function MobNavbar() {
  return (
    <>
      <Col className="mobNavbar p-3 d-block d-lg-none">
        <Col className="text-center">
          <img
            src={Profile}
            alt="sivarm farms prodile"
            height="auto"
            width="60%"
          />
        </Col>
        <Col className="mobNavbarMenu mt-4">
          <ul>
            <li>
              <Link to="/notification">
                <RiNotificationBadgeFill
                  className="text-dark me-1"
                  style={{ fontSize: "1em" }}
                />
                Notifications
              </Link>
            </li>
            <li>
              <Link to="/userDetails">
                <RiShieldUserFill
                  className="text-dark me-1"
                  style={{ fontSize: "1em" }}
                />
                Managing Users
              </Link>
            </li>
            <li>
              <Link to="/productDetails">
                <RiShoppingCartFill
                  className="text-dark me-1"
                  style={{ fontSize: "1em" }}
                />
                Product List
              </Link>
            </li>
            <li>
              <Link to="/productOfMonth">
                <BsFillCalendarEventFill
                  className="text-dark me-2"
                  style={{ fontSize: "1em" }}
                />
                Product Of The Month
              </Link>
            </li>
            <li>
              <Link to="/courier">
                <GrDeliver
                  className="text-dark me-2"
                  style={{ fontSize: "1em" }}
                />
                Courier
              </Link>
            </li>
            <li>
              <Link to="/">
                <FaPowerOff
                  className="text-dark me-1"
                  style={{ fontSize: "1em" }}
                />
                Logout
              </Link>
            </li>
          </ul>
        </Col>
      </Col>
    </>
  );
}
